import React from 'react';
import './PlatformBadges.css';

const PlatformBadges = ({ selectedPlatform, onPlatformSelect }) => {
  const platforms = [
    {
      id: 'tiktok',
      name: 'TikTok',
      icon: '🎵',
      active: true,
      status: 'Active'
    },
    {
      id: 'youtube',
      name: 'YouTube',
      icon: '▶️',
      active: true,
      status: 'Active'
    }
  ];

  return (
    <div className="platform-badges">
      {platforms.map((platform, index) => (
        <div 
          key={index} 
          className={`platform-badge ${platform.active ? 'active' : 'coming-soon'} ${selectedPlatform === platform.id ? 'selected' : ''}`}
          onClick={() => platform.active && onPlatformSelect(platform.id)}
          style={{ cursor: platform.active ? 'pointer' : 'not-allowed' }}
        >
          <span className="platform-icon">{platform.icon}</span>
          <div className="badge-label">
            <span className="badge-name">{platform.name}</span>
            {!platform.active && (
              <span className="badge-status">{platform.status}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlatformBadges;
